import type { Option } from "src/components/SelectV2/SelectV2.types.ts";
import React, { type ReactNode } from "react";

import { selectClasses } from "src/components/SelectV2/SelectV2.constants.ts";
import * as styles from "src/components/SelectV2/SelectV2.style.ts";
import { SpinnerSpinningMini as Spinner } from "src/lib/ui-icon-v2";

export const ButtonPreview = <Value = unknown,>({
  disabled,
  placeholder,
  flatOptions,
  isLoadingData,
  isLoadingSelectedOption,
  value,
  fallbackOptions,
  isOpen,
}: {
  disabled: boolean;
  flatOptions: Option<Value>[];
  placeholder?: ReactNode;
  isLoadingData: boolean;
  isLoadingSelectedOption: boolean;
  value: Value | "";
  fallbackOptions: Option<NoInfer<Value>>[];
  isOpen: boolean;
}) => {
  const selectedOption = [...flatOptions, ...fallbackOptions].find(
    (option) => option.value === value,
  );

  return (
    <div
      className={selectClasses.preview}
      css={styles.preview({
        disabled: disabled,
        isPlaceholder: !selectedOption,
        isButton: true,
        isOpen,
      })}
    >
      {isLoadingSelectedOption ? (
        <Spinner />
      ) : selectedOption?.renderOption ? (
        selectedOption?.renderOption(selectedOption)
      ) : (
        <div css={styles.previewInner}>
          {selectedOption ? selectedOption?.label : placeholder}
        </div>
      )}
    </div>
  );
};
